import React from 'react';
import styled from 'styled-components';
import { ResolvedStateExtended, SlackNotificationsSettings } from '../../../../../shared/types/types';
import SlackNotificationToggleMolecule from './SlackNotificationToggleMolecule';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

interface Props {
  notifications: SlackNotificationsSettings,
  // eslint-disable-next-line no-unused-vars
  updateSlackNotifications: (val: SlackNotificationsSettings) => void,
  isResolved: ResolvedStateExtended,
}

const SlackNotificationsOrganism = ({
  notifications,
  updateSlackNotifications,
  isResolved,
}: Props) => (
  <Container>
    <SlackNotificationToggleMolecule
      notifications={notifications}
      updateSlackNotifications={updateSlackNotifications}
      isResolved={isResolved}
    />
  </Container>
);

export default SlackNotificationsOrganism;
